import analytics from './analytics';
let currentPage = null;

// Object wrapped strings are typed as objects: https://stackoverflow.com/a/4059166
const isValidPageName = (str) =>
  Boolean(str) && (typeof str === 'string' || str instanceof String);
const trimLabel = (str) => (str !== null ? String(str).trim() : '');
const getLocationPath = () => window?.location?.pathname;
const withPageAttributes = (attributes) => {
  if (!isValidPageName(currentPage)) {
    return attributes;
  }
  return {
    ...attributes,
    page: currentPage
  };
};

// Meant to be a layer between our application and analytics logging
// Docs for window.analytics
// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
const logger = {
  get currentPage() {
    return currentPage;
  },

  set currentPage(value) {
    currentPage = value;
  },

  logPageView(category = null, page = null, attributes = {}) {
    if (isValidPageName(page)) {
      currentPage = page;
    }

    analytics.page(category, page, attributes);
  },

  bindLinkTracking(el, { elementId, label, ...properties }) {
    const eventProperties = withPageAttributes({
      element: elementId,
      label: trimLabel(label),
      path: getLocationPath(),
      ...properties
    });
    analytics.trackLink(el, 'Element Clicked', eventProperties);
  },

  trackElementClicked({ elementId, label, ...properties }) {
    const eventProperties = withPageAttributes({
      element: elementId,
      label: trimLabel(label),
      path: getLocationPath(),
      ...properties
    });
    analytics.track('Element Clicked', eventProperties);
  },

  identify(userId) {
    analytics.alias(userId);
    analytics.identify(userId, {
      ramsey_plus_web_app_last_used: new Date(Date.now()).toISOString(),
      ramsey_plus_web_app_user: true
    });
  },

  trackElementViewed({ elementId, label, ...properties }) {
    const eventProperties = withPageAttributes({
      element: elementId,
      label: trimLabel(label),
      path: getLocationPath(),
      ...properties
    });
    analytics.track('Element Viewed', eventProperties);
  }
};

export default logger;
